<h3 class="section-title">Lot & Build</h3>
<div class="grid" [formGroup]="lotForm">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-3">
        <mat-label>Lot Contract Type</mat-label>
        <mat-select formControlName="LotContractType" required>
            @for (contractType of contractTypes; track contractType) {
                <mat-option [value]="contractType.label">
                    {{ contractType.label }}
                </mat-option>
            }
        </mat-select>
        @if (hasError('LotContractType')) {
            <mat-error>{{ getErrorMessage('LotContractType', 'Lot Contract Type') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-3">
        <mat-label>Lot Type</mat-label>
        <mat-select [disabled]="true" formControlName="LotType" required>
            @for (lotType of lotTypes; track lotType) {
                <mat-option [disabled]="true" [value]="lotType.label">
                    {{ lotType.label }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-3">
        <mat-label>Lot Build Type</mat-label>
        <mat-select formControlName="LotBuildType" required>
            @for (buildType of buildTypeOptions; track buildType) {
                <mat-option [value]="buildType.code">
                    {{ buildType.code }}
                </mat-option>
            }
        </mat-select>
        @if (hasError('LotBuildType')) {
            <mat-error>{{ getErrorMessage('LotBuildType', 'Lot Build Type') }}</mat-error>
        }
    </mat-form-field>

    @if (showAreas) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-3">
            <mat-label>Floor Area</mat-label>
            <input
                matInput
                type="text"
                inputmode="decimal"
                formControlName="FloorArea"
            >
            <span matSuffix class="cb-margin-right"> m2</span>
            @if (hasError('FloorArea')) {
                <mat-error>{{ getErrorMessage('FloorArea', 'Floor Area') }}</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-3">
            <mat-label>Land Area</mat-label>
            <input
                matInput
                type="text"
                inputmode="decimal"
                formControlName="LandArea"
            >
            <span matSuffix class="cb-margin-right"> m2</span>
            @if (hasError('LandArea')) {
                <mat-error>{{ getErrorMessage('LandArea', 'Land Area') }}</mat-error>
            }
        </mat-form-field>
    }

    @if (showBuildTypeLink) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-6">
            <mat-label>Build Type Link</mat-label>
            <input [readonly]="true" [disabled]="true" matInput formControlName="BuildTypeLink">
            @if (hasError('BuildTypeLink')) {
                <mat-error>{{ getErrorMessage('BuildTypeLink', 'Build Type Link') }}</mat-error>
            }
        </mat-form-field>
    }
</div>
